const toStoryStatus = (status) => (status === "not_started" ? null : status);

export const clozeTextToStory = (clozeText) => {
  let sentenceNumber = 0;
  return {
    averageDifficulty: clozeText.averageDifficulty,
    category: clozeText.category,
    cefrLevel: clozeText.cefrLevel ?? "",
    difficulty: clozeText.difficulty,
    emoji: clozeText.emoji,
    id: clozeText.id,
    isOwn: !!clozeText.isOwn,
    paragraphs: clozeText.paragraphs.map((paragraph) => ({
      sentences: paragraph.sentences.map((sentence) => ({
        cloze: sentence.cloze
          ? { after: sentence.postClozeStr ?? "", answer: sentence.cloze, before: sentence.preClozeStr ?? "", options: sentence.options }
          : null,
        id: ++sentenceNumber,
        text: sentence.text,
        translation: sentence.translation,
        ttsUrl: sentence.ttsUrl
      }))
    })),
    slug: clozeText.slug,
    sourceName: clozeText.sourceName,
    sourceUrl: clozeText.sourceUrl,
    status: toStoryStatus(clozeText.progress.status),
    title: clozeText.title,
    translatedTitle: null,
    translationLanguageId: null
  };
};

export const clozeTextSummaryToStorySummary = (clozeText) => ({
  category: clozeText.category,
  cefrLevel: clozeText.cefrLevel ?? "",
  emoji: clozeText.emoji,
  id: clozeText.id,
  slug: clozeText.slug,
  status: toStoryStatus(clozeText.progress.status),
  title: clozeText.title,
  wordCount: clozeText.wordCount
});

const SAVED_ANSWER_STATUSES = { a: "attempted", c: "correct", i: "incorrect" };

export const getSavedClozeStatuses = (progress) =>
  Object.fromEntries(Object.entries(progress.sentences).map(([sentenceId, result]) => [sentenceId, SAVED_ANSWER_STATUSES[result]]));

export const buildClozeTextAnswer = (sentenceId, previousStatus, isCorrect) => {
  if (previousStatus === "correct" || previousStatus === "incorrect") return null;
  if (!isCorrect) return previousStatus ? null : { complete: false, correct: false, sentenceId };
  return { complete: true, correct: !previousStatus, sentenceId };
};
